/**
* Copyright (c) 2018 Microsoft Corporation
* Modules Registration
* THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
*/
const { log, error }  = console;
const detailedWebpackError = (msg, errorObject) => { error(msg); error(errorObject); process.env.NODE_ENV !== 'development' && error('Run in dev mode to see full list of errors'); process.exit(50); }
const handleError = (modPath, errObject) => {
    detailedWebpackError('Error with path: ' + modPath, errObject);
}

const handleMissingImplementationDetails = (functionName, connectorName, connectorType) => {
    error('----ERROR: CONNECTOR MISSING IMPLEMENTATION DETAILS-----');
    error('Missing function ' + functionName + ' from ' + connectorType + ' implementation for experimentation connector ' + connectorName);
    throw new Error('Connector missing implementation details');
}

const verifySegmentationRegistration = (connectorName) => {
    const segmentationProvider = connectorDictionary[connectorName].provider;
    try {
        if (!segmentationProvider.__proto__.initialize) {
            handleMissingImplementationDetails('initialize', connectorName, 'provider');
        }
        if (!segmentationProvider.__proto__.getSegmentations) {
            handleMissingImplementationDetails('getSegmentations', connectorName, 'provider');
        }
    } catch (e) {
        // Connector has not implemented all the required methods, setting registration as undefined
        connectorDictionary[connectorName] = undefined;
        throw e;
    }
}

const isServer = ()=>{
    return ! (typeof window != 'undefined' && window.document);
}

const verifyGeoLookupRegistration = (connectorName) => {
    const geoLookupProvider = connectorDictionary[connectorName].provider;
    try {
        if (!geoLookupProvider.__proto__.initialize) {
            handleMissingImplementationDetails('initialize', connectorName, 'provider');
        }
        if (!geoLookupProvider.__proto__.getGeoInformation) {
            handleMissingImplementationDetails('getGeoInformation', connectorName, 'provider');
        }
    } catch (e) {
        // Connector has not implemented all the required methods, setting registration as undefined
        connectorDictionary[connectorName] = undefined;
        throw e;
    }
}

const verifyExperimentationReigstration = (connectorName) => {
    const connectorImpl = connectorDictionary[connectorName].provider;
    const connectorListenerImpl = connectorDictionary[connectorName].listener;
    try {
        if (!connectorImpl.__proto__.initialize) {
            handleMissingImplementationDetails('initialize', connectorName, 'provider');
        }
        if (!connectorImpl.__proto__.getConfigForClientSideInit) {
            handleMissingImplementationDetails('getConfigForClientSideInit', connectorName, 'provider');
        }
        if (!connectorImpl.__proto__.initializeClientSide) {
            handleMissingImplementationDetails('initializeClientSide', connectorName, 'provider');
        }
        if (!connectorImpl.__proto__.getExperiments) {
            handleMissingImplementationDetails('getExperiments', connectorName, 'provider');
        }
        if (!connectorImpl.__proto__.getVariantsForUser) {
            handleMissingImplementationDetails('getVariantsForUser', connectorName, 'provider');
        }
        if (!connectorImpl.__proto__.activateExperiment) {
            handleMissingImplementationDetails('activateExperiment', connectorName, 'provider');
        }
        if (!connectorListenerImpl.__proto__.initializeClientSide) {
            handleMissingImplementationDetails('initializeClientSide', connectorName, 'listener');
        }
        if (!connectorListenerImpl.__proto__.logEvent) {
            handleMissingImplementationDetails('logEvent', connectorName, 'listener');
        }
    } catch (e) {
        // Connector has not implemented all the required methods, setting registration as undefined
        connectorDictionary[connectorName] = undefined;
        throw e;
    }
}

export const connectorDictionary = {};


    {
        const connectorName = '100';
        
        let connectorProviderImpl = require('partner/connectors/msdyn365-geoLookup-maxmind/msdyn365-seg-test-1.provider');
        if (!connectorProviderImpl.default) {
            throw new Error('segmentation Connector provider 100 does not have a default export. Check the provider file of the connector for a default export.');
        }
        connectorDictionary[connectorName] = {provider: connectorProviderImpl.default};
    }

    {
        const connectorName = 'Optimizely';
        
        let connectorProviderImpl = require('@msdyn365-commerce-thirdpartyconnectors/exp-connector-optimizely/dist/lib/connectors/optimizely-connector/optimizely-connector.provider');
        let connectorListenerImpl = require('@msdyn365-commerce-thirdpartyconnectors/exp-connector-optimizely/dist/lib/connectors/optimizely-connector/optimizely-connector.listener');
        let connectorDomainsList = '';
        if (!connectorProviderImpl.default) {
            throw new Error('Exp Connector provider Optimizely does not have a default export. Check the provider file of the connector for a default export.');
        }
        if (!connectorListenerImpl.default) {
            throw new Error('Exp Connector listener Optimizely does not have a default export. Check the listener file of the connector for a default export.');
        }
        connectorDictionary[connectorName] = {provider: connectorProviderImpl.default, listener: connectorListenerImpl.default, connectorDomains: connectorDomainsList};
    }

    {
        const connectorName = 'geoLookup-maxmind';
        
        if (isServer()) {
            let connectorProviderImpl = require('partner/connectors/msdyn365-geoLookup-maxmind/msdyn365-geoLookup-maxmind.provider');
            if (!connectorProviderImpl.default) {
                throw new Error('Geo Lookup Connector provider geoLookup-maxmind does not have a default export. Check the provider file of the connector for a default export.');
            }
            connectorDictionary[connectorName] = {provider: connectorProviderImpl.default};
        }
    }

    {
        const connectorName = 'msdyn365-exp-test';
        
        let connectorProviderImpl = require('@msdyn365-commerce-modules/msdyn365-exp-test-connector/dist/lib/connectors/msdyn365-exp-test/msdyn365-exp-test.provider');
        let connectorListenerImpl = require('@msdyn365-commerce-modules/msdyn365-exp-test-connector/dist/lib/connectors/msdyn365-exp-test/msdyn365-exp-test.listener');
        let connectorDomainsList = 'https://msdyn365-exp-test.com ';
        if (!connectorProviderImpl.default) {
            throw new Error('Exp Connector provider msdyn365-exp-test does not have a default export. Check the provider file of the connector for a default export.');
        }
        if (!connectorListenerImpl.default) {
            throw new Error('Exp Connector listener msdyn365-exp-test does not have a default export. Check the listener file of the connector for a default export.');
        }
        connectorDictionary[connectorName] = {provider: connectorProviderImpl.default, listener: connectorListenerImpl.default, connectorDomains: connectorDomainsList};
    }

export const validateConnectorRegistration = () => {
    
    verifySegmentationRegistration('100');

    verifyExperimentationReigstration('Optimizely');

    if (isServer()) {
        verifyGeoLookupRegistration('geoLookup-maxmind');}

};